import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import Button from 'layout/atoms/Button/Button';
import ConfirmationModal from 'layout/molecules/ConfirmationModal';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { removeStoreFolderSpecification, setRefetchFlag } from 'store/specificationsFoldersSlice';
import { removeSpecification, selectSpecificationsStatus, setRefetchFlag as setMyFilesRefetchFlag, } from 'store/specificationsSlice';
function RemoveSpecificationModal() {
    var _a;
    const { t } = useTranslation(['specification']);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const specificationsStatus = useSelector(selectSpecificationsStatus);
    const modalData = (_a = useSelector(selectModalByName('removeSpecification'))) === null || _a === void 0 ? void 0 : _a.data;
    const modelSpecificationId = modalData === null || modalData === void 0 ? void 0 : modalData.id;
    const itemCode = modalData === null || modalData === void 0 ? void 0 : modalData.itemCode;
    const isCreatorContext = modalData === null || modalData === void 0 ? void 0 : modalData.creator;
    const prevPath = (modalData === null || modalData === void 0 ? void 0 : modalData.prevPath) || '/specifications';
    const handleRemoveModel = () => {
        dispatch(removeSpecification({ modelSpecificationId }))
            .unwrap()
            .then(() => {
            dispatch(closeModal({ name: 'removeSpecification' }));
            dispatch(removeStoreFolderSpecification({ id: modelSpecificationId }));
            dispatch(setRefetchFlag({ flag: 'fetch', value: true }));
            dispatch(setMyFilesRefetchFlag({ flag: 'fetch', value: true }));
            if (isCreatorContext) {
                dispatch(closeModal({ name: 'specificationCreator' }));
            }
            else {
                navigate(prevPath);
            }
        });
    };
    return (React.createElement(ConfirmationModal, { name: "removeSpecification", header: React.createElement(React.Fragment, null,
            React.createElement(TrashSvg, null),
            t('REMOVE_SPECIFICATION')), buttons: React.createElement(Button, { color: "danger", onClick: handleRemoveModel }, t('common:delete')), action: handleRemoveModel, loading: specificationsStatus.remove === 'loading' },
        React.createElement("h2", null, t('REMOVE_SPECIFICATION_HEADER', { itemCode })),
        React.createElement("p", null, t('REMOVE_SPECIFICATION_MESSAGE'))));
}
export default memo(RemoveSpecificationModal);
